import {createApi, fetchBaseQuery} from "@reduxjs/toolkit/query/react";
import {jsonStorage} from "@/utils/jsonStorage";
import {appkit} from "@/appkit.ts";

export enum ApiTag {
  hasAuth = "hasAuth",
  auth = "auth",
  claim = "claim",
  purchase = "purchase",
  swapRate = "swapRate",
  swapDeposit = "swapdeposit",
  swapStatus = "swapStatus",
  poolStats = "poolStats",
  transactionsStats = "transactionsStats",
  swapAddr = "swapAddr",
  swapData = "swapData",
  claimData = "claimData",
  profile = "profile",
  jupiter = "jupiter",
  getRefCodeAndPoints = "getRefCodeAndPoints",
}

// const baseUrl =  "http://localhost:8080";
const baseUrl = import.meta.env?.VITE_API_BASE_URL ?? "https://api.zenexhub.com";

export const api = createApi({
  reducerPath: "api",
  endpoints: () => ({}),
  tagTypes: Object.values(ApiTag),
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, {arg}) => {
      const customArg = (arg as any)?.arg;
      const token = customArg?.token;


      // console.log("za.arg", arg,customArg, token);
      if (token) {
        // console.log('za.token',token);
        const sessionBase64 = btoa(token);
        if (sessionBase64) {
          headers.set("X-AUTH-ZNX", sessionBase64);
        } else {
          throw Error("No session");
        }
      }


      const locale = jsonStorage.getItem("locale", "en");

      if (locale) headers.set("Accept-Language", locale);

      return headers;
    },
  }),
});
